declare let DigitalIdentityHub;

export const Common = {
  name: "UsCommon",
  ready() {
    // Register custom client-side validators
    window.DigitalIdentityHub.utilities.registerValidation("postalCodeValidation", (_name, value) => /^\d{5}$/.test(value));
    window.DigitalIdentityHub.utilities.registerValidation("passwordValidation", (_name, value) =>
      /^((?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,16})|((?=.*[a-z])(?=.*[A-Z])(?=.*[{}.,()=<>/`\-_!@#$%^&*?]).{8,16})|((?=.*[a-z])(?=.*[{}.,()=<>/`\-_!@#$%^&*?])(?=.*\d).{8,16})|((?=.*[{}.,()=<>/`\-_!@#$%^&*?])(?=.*[A-Z])(?=.*\d).{8,16})$/.test(
        value
      )
    );
    window.DigitalIdentityHub.utilities.registerValidation("firstNameValidation", (_name, value) =>
      // eslint-disable-next-line no-useless-escape
      /(?=^.{1,30}$)(^[A-Za-z]+[^0-9`~!@#$%^&*()+=|\\\[\]{}":;,/?><_\r\n]*$)/.test(value)
    );
    window.DigitalIdentityHub.utilities.registerValidation("lastNameValidation", (_name, value) =>
      // eslint-disable-next-line no-useless-escape
      /(?=^.{2,60}$)(^[A-Za-z]+[^0-9`~!@#$%^&*()+=|\\\[\]{}":;,/?><_\r\n]*$)/.test(value)
    );
    window.DigitalIdentityHub.utilities.registerValidation("cityFormatValidation", (_name, value) =>
      // eslint-disable-next-line no-useless-escape
      /(?=^.{2,30}$)(^[A-Za-z]+[^0-9`~!@#$%^&*()+=|\\{}":;,/\[\]?><_\r\n]*$)/.test(value)
    );
    window.DigitalIdentityHub.utilities.registerValidation("phoneValidation", (_name, value) => /^(\d{3}-\d{3}-\d{4})$/.test(value));
    window.DigitalIdentityHub.utilities.registerValidation("emailValidation", (_name, value) => /^[A-Z0-9a-z._%+\-'"]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,6}$/.test(value));
    window.DigitalIdentityHub.utilities.registerValidation("preregEmailValidation", (_name, value) => /^[A-Z0-9a-z._%+\-'"]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,6}$/.test(value));
    window.DigitalIdentityHub.utilities.setLanguage("en-US");

    // Dynamic Email Validation for pre-reg user
    const preregEmailValidationRequired = (_name, value) => value !== "";

    const customValidation = DigitalIdentityHub.getModule("CustomValidation");
    customValidation.add("preregEmailAddress", preregEmailValidationRequired, "Email is required.");

    janrain.events.onCaptureRenderComplete.addHandler(result => {
      if (result.screen === "createPassword") {
        DigitalIdentityHub.utilities.getCaptureField("createPassword", "emailVerifiedHidden").value = new Date().toISOString();
      }
    });

    // Custom Validation for License Number
    const validateLicenseNumber = (_name, value) => {
      const licenseTypeSelection = document.getElementById("capture_" + janrain.settings.capture.currentScreenName + "_licenseType") as HTMLSelectElement;
      const licenseTypeValueSelected = licenseTypeSelection.options[licenseTypeSelection.selectedIndex].value;
      const licenseTypeLabelSelected = licenseTypeSelection.options[licenseTypeSelection.selectedIndex].label;

      if (licenseTypeValueSelected === "NPI") {
        return /^(\d{10})$/.test(value);
      }
      if (licenseTypeValueSelected === "AMA") {
        return /^(\d{11})$/.test(value);
      }
      if (licenseTypeLabelSelected === "Select a license type") {
        return value !== "";
      }
      return true;
    };
    window.DigitalIdentityHub.utilities.registerValidation("licenseNumberValidation", validateLicenseNumber);

    const errorObj: object = {};

    // Custom Dynamic Fields
    janrain.events.onCaptureRenderComplete.addHandler(result => {
      if ((result.screen === "traditionalRegistration" || result.screen === "editProfile") && result.renderingBuiltInScreen === false) {
        const officeManager = "09-OT-OT-OFM";

        const currentScreenName = result.screen;
        const customerTypeSelect = document.getElementById(`capture_${currentScreenName}_customerType`) as HTMLSelectElement;
        const licenseTypeFormItem = document.getElementById(`capture_${currentScreenName}_form_item_licenseType`);
        const licenseTypeSelect = document.getElementById(`capture_${currentScreenName}_licenseType`) as HTMLSelectElement;
        const licenseNumberFormItem = document.getElementById(`capture_${currentScreenName}_form_item_licenseNumber`);
        const licenseNumberInput = document.getElementById(`capture_${currentScreenName}_licenseNumber`) as HTMLInputElement;
        const specialtyTypeFormItem = document.getElementById(`capture_${currentScreenName}_form_item_mainSpecialty`);
        const specialtyTypeSelect = document.getElementById(`capture_${currentScreenName}_mainSpecialty`) as HTMLSelectElement;

        const editProfileCard1 = document.getElementById("card1");
        const editProfileCard2 = document.getElementById("card2");
        const editProfileCard3 = document.getElementById("card3");

        const fieldValues = {};

        const submitForm = () => {
          janrain.capture.ui.postCaptureForm("editProfileForm", fieldValues);
        };

        const createFormObject = event => {
          const name = event.target.name;
          fieldValues[`${name}`] = event.target.value;
        };

        const clearFormObject = () => {
          Object.keys(fieldValues).forEach(key => delete fieldValues[key]);
        };

        const formField = [...Array.from(document.querySelectorAll("form div.sso-card input")), ...Array.from(document.querySelectorAll("form div.sso-card select"))];

        formField.forEach(field => field.addEventListener("change", createFormObject));

        const cancelBtns = [...Array.from(document.querySelectorAll(".cancel"))];
        cancelBtns.forEach(btn => {
          (btn as HTMLButtonElement).addEventListener("click", function() {
            const editProfileForm = document.getElementById("capture_editProfile_editProfileForm") as HTMLFormElement;
            editProfileForm.reset();
            if (customerTypeSelect.value === officeManager) {
              specialtyTypeFormItem.style.display = "none";
              specialtyTypeSelect.value = "OS";
              licenseTypeFormItem.style.display = "none";
              licenseNumberFormItem.style.display = "none";
              licenseNumberInput.value = "";
            } else {
              if (previousCustomerTypeValue === officeManager) {
                specialtyTypeSelect.value = ""; // Reset the specialty field if the previous customer type === 'OFM'.
                specialtyTypeSelect.dispatchEvent(new Event("change"));
              }

              specialtyTypeFormItem.style.display = "block";
              licenseTypeFormItem.style.display = "block";
              licenseNumberFormItem.style.display = "block";

              if (licenseTypeSelect.value === "") {
                licenseNumberFormItem.classList.add("disabled");
                licenseNumberInput.setAttribute("disabled", "true");
              } else {
                licenseNumberFormItem.classList.remove("disabled");
                licenseNumberInput.removeAttribute("disabled");
              }
            }
            // Clear fieldValues object
            clearFormObject();
          });
        });

        licenseTypeSelect.onchange = function() {
          if ((this as HTMLSelectElement).value !== "") {
            licenseNumberInput.removeAttribute("disabled");
            licenseNumberFormItem.classList.remove("disabled");
          } else {
            licenseNumberInput.value = "";
            licenseNumberInput.focus();
            licenseNumberInput.blur();
            Object.keys(errorObj).forEach(key => {
              console.log(`Key: ${key}`);
              if (key === "capture_traditionalRegistration_licenseNumber") {
                console.log("Deleting the value from the obj");
                delete errorObj[key];
                (licenseNumberFormItem.querySelector<HTMLElement>("div.capture_tip_error")).innerText = "";
              }
            });
            licenseNumberInput.dispatchEvent(new Event("change"));
            licenseNumberInput.setAttribute("disabled", "");
            licenseNumberFormItem.classList.add("disabled");
          }
        };

        // On change handling for Designation (CustomerType): If a user selects Office Manager the License Type field will disappear AND Specialty will be populated by 'OTHER';
        let previousCustomerTypeValue = customerTypeSelect.value;

        customerTypeSelect.onchange = function() {
          const newCustomerTypeValue = (this as HTMLSelectElement).value;

          if (newCustomerTypeValue === officeManager) {
            specialtyTypeSelect.value = "OS";
            specialtyTypeSelect.focus();
            specialtyTypeSelect.blur();
            specialtyTypeFormItem.style.display = "none";
            specialtyTypeSelect.dispatchEvent(new Event("change"));
            licenseTypeFormItem.style.display = "none";
            licenseTypeSelect.value = "";
            licenseTypeSelect.dispatchEvent(new Event("change"));
            licenseNumberFormItem.style.display = "none";
            licenseNumberInput.value = "";
            licenseNumberInput.focus();
            licenseNumberInput.blur();
            licenseNumberInput.value = "";
            licenseNumberInput.dispatchEvent(new Event("change"));
            document.getElementById("progress-step-4").removeAttribute("disabled");
          } else {
            // else statement will display the license Type field if any other value is selected.
            if (previousCustomerTypeValue === officeManager) {
              specialtyTypeSelect.value = ""; // Reset the specialty field if the previous customer type === 'OFM'.
              specialtyTypeSelect.dispatchEvent(new Event("change"));
            }

            specialtyTypeFormItem.style.display = "block";
            licenseTypeFormItem.style.display = "block";
            licenseNumberFormItem.style.display = "block";

            if (licenseTypeSelect.value === "") {
              licenseNumberFormItem.classList.add("disabled");
              licenseNumberInput.setAttribute("disabled", "true");
            }
          }
          previousCustomerTypeValue = newCustomerTypeValue; // Set the previousValue to the newValue.
        };

        if (result.screen === "editProfile" && result.renderingBuiltInScreen === false) {
          if (licenseTypeSelect.value === "") {
            licenseNumberFormItem.classList.add("disabled");
            licenseNumberInput.setAttribute("disabled", "true");
          }

          editProfileCard1.style.display = "block";
          editProfileCard2.style.display = "block";
          editProfileCard3.style.display = "block";

          if (customerTypeSelect.value !== officeManager) {
            licenseTypeFormItem.style.display = "block";
          } else {
            specialtyTypeFormItem.style.display = "none";
            licenseTypeFormItem.style.display = "none";
            licenseNumberFormItem.style.display = "none";
          }

          // Change email button
          const changeEmailBtn = document.getElementById("capture_editProfile_changeEmail");
          changeEmailBtn.addEventListener("click", function() {
            const consentHubHost = document.getElementById("ConsentHubHost");
            if (consentHubHost) {
              consentHubHost.style.display = "none";
            }
            document.getElementById("card1").style.display = "none";
            document.getElementById("card1a").style.display = "none";
            document.getElementById("card2").style.display = "none";
            document.getElementById("card3").style.display = "none";
            document.getElementById("emailChange_Confirm").setAttribute("disabled", "true");
          });

          /**
           * Dynamically displays edit profile updated success message.
           *
           * Determines which of the two submit buttons were clicked and only shows the success message
           * on that card. It also changes the button text from "Submit" to "Changes saved"
           */

          const saving = "Saving...";

          const waitForContentToLoad = (id: string, btnEl: HTMLButtonElement) => {
            const saved = "Changes saved";
            btnEl.textContent = saving;
            return new Promise(resolve => {
              const interval = setInterval(() => {
                const msgHasLoaded = document.querySelector(`${id}`);
                if (msgHasLoaded) {
                  btnEl.textContent = saved;
                  btnEl.classList.add("changes-saved");
                  clearInterval(interval);
                  resolve(msgHasLoaded);
                }
              }, 100);
            });
          };

          const applyEventListenerToDOM = (btnEl: HTMLElement, btnMsg: string) => {
            const formInputs = Array.from(document.querySelectorAll('div[id*="capture_editProfile_form_item"]'));
            Array.from(document.querySelectorAll('li[class*="widget-channel-form-preference"]')).forEach(i => formInputs.push(i));
            const inputId: string[] = [];
            formInputs.forEach(element => {
              const inputElement = element.children[1];
              return inputElement.nodeName === "INPUT"
                ? inputId.push(inputElement.id)
                : (inputElement.children[0]).nodeName === "SELECT"
                  ? inputId.push(inputElement.children[0].id)
                  : element.children[0].nodeName === "INPUT"
                    ? inputId.push(element.children[0].id)
                    : false;
            });

            inputId.forEach(id => {
              document.getElementById(`${id}`).addEventListener("click", function() {
                btnEl.textContent = btnMsg;
                btnEl.classList.remove("changes-saved");
              });
            });
          };

          void Promise.all([waitForCOHWidgetToLoad(".widget-consent")]).then(() => {
            const cohSubmitBtn = document.querySelector<HTMLButtonElement>('.widget-channel-form-button[type="submit"]');
            cohSubmitBtn.textContent = "Save changes";
            cohSubmitBtn.addEventListener("click", () => {
              const initialCohSubmitBtnText = cohSubmitBtn.textContent;
              void Promise.all([waitForContentToLoad(".widget-channel-form-status", cohSubmitBtn)]).then(() => {
                cohSubmitBtn.classList.add("sso-btn-save");
                applyEventListenerToDOM(cohSubmitBtn, initialCohSubmitBtnText);
              });
            });
          });

          let submitBtnUsed = sessionStorage.getItem("clicked");

          if (submitBtnUsed) {
            sessionStorage.removeItem("clicked");

            const submitButton = document.getElementById(submitBtnUsed);
            const initialSubmitButtonText = submitButton.textContent;
            void Promise.all([waitForContentToLoad(".editProfile-message", submitButton as HTMLButtonElement)]).then(() => {
              applyEventListenerToDOM(submitButton, initialSubmitButtonText);
            });
          }

          const submitBtn = Array.from(document.querySelectorAll(".sso-settings-save button.sso-btn.sso-btn--small.sso-btn--primary.sso-btn-save"));

          submitBtn.forEach(btn =>
            btn.addEventListener("click", event => {
              const submitButton = document.querySelector(`#${(event.target as HTMLButtonElement).id}`);
              submitButton.textContent = saving;
              submitBtnUsed = (event.target as HTMLInputElement).id;
              submitForm();
              return sessionStorage.setItem("clicked", submitBtnUsed);
            })
          );
        }
      }

      //#region US emailVerificationNotification flow

      if (result.screen === "emailVerificationNotification" && result.renderingBuiltInScreen === false) {
        /**
         * Display user email in emailVerificationNotification screen.
         *
         * Extracts users Janrain email from localStorage.janrainCaptureProfileData.
         * Selects HTML <span> element and inserts email text.
         */

        // Function returns a promise when window.localStorage.janrainCaptureProfileData is found.
        const waitForLocalStorageProfileData = (): Promise<void> => {
          return new Promise(resolve => {
            const interval = setInterval(() => {
              if (window.localStorage.janrainCaptureProfileData) {
                clearInterval(interval);
                resolve();
              }
            }, 100);
          });
        };

        void Promise.all([waitForLocalStorageProfileData()]).then(() => {
          const localProfile = JSON.parse(localStorage.janrainCaptureProfileData || "{}");
          const userEmail = localProfile.email;

          const emailSpan = document.getElementById("userEmail");
          emailSpan.style.fontWeight = "bold";
          emailSpan.innerText = userEmail;

          const emailInput = document.getElementById("capture_emailVerificationNotification_signInEmailAddress") as HTMLInputElement;
          emailInput.value = userEmail;
        });
      }
      //#endregion US emailVerificationNotification flow

      //#region edit profile logic

      if (result.screen === "editProfile") {
        document.getElementById("changePasswordScreenView").addEventListener("click", ()=>{
          document.getElementById("editProfile").style.display = "none";
          janrain.capture.ui.renderScreen("changePassword");
        });
      }

      /**
       * Displays changePasswordSuccessMessage on edit profile screen.
       */
      if (result.screen === "changePasswordSuccessMessage" || (result.screen === "editProfile" && janrain.settings.capture.prevScreenName === "changePasswordSuccessMessage")) {
        const initialScreenToCopy = document.getElementById("changePasswordSuccessMessage");

        if (result.screen === "changePasswordSuccessMessage") {
          if (initialScreenToCopy) {
            initialScreenToCopy.style.display = "none";
            janrain.capture.ui.renderScreen("editProfile");
          }
        }

        if (result.screen === "editProfile") {
          const duplicateScreen = initialScreenToCopy.cloneNode(true);
          (duplicateScreen as HTMLElement).classList.add("duplicate");
          (duplicateScreen as HTMLElement).style.display = "block";
          const editProfileForm = document.getElementById("capture_editProfile_editProfileForm");
          const card1 = document.getElementById("card1");
          editProfileForm.insertBefore(duplicateScreen, card1);
        }
      }
      //#endregion edit profile logic
    });

    janrain.events.onCaptureRenderComplete.addHandler(result => {
      if (result.screen === "emailVerificationRequired" || result.screen === "pendingUser") {
        if (janrain.settings.capture.prevScreenName === "traditionalRegistration" || janrain.settings.capture.prevScreenName === "emailVerificationNotification") {
          janrain.capture.ui.renderScreen("emailVerificationNotification");
        }
      }
    });

    //#region Unmasking Password

    // OnCaptureContentChanged - add and remove eye mask
    janrain.events.onCaptureRenderComplete.addHandler(result => {
      if (result.screen === "traditionalRegistration" && result.renderingBuiltInScreen === false) {
        const newBtn = Array.from(document.querySelectorAll(".eyeBtnNew"));
        const confirmBtn = Array.from(document.querySelectorAll(".eyeBtnConfirm"));
        const tradPwdField = document.querySelector<HTMLInputElement>("#capture_traditionalRegistration_newPassword");
        const tradConfirmPwdField = document.querySelector<HTMLInputElement>("#capture_traditionalRegistration_newPasswordConfirm");

        // Un-masking in traditional registration
        newBtn.forEach(button =>
          button.addEventListener("click", () => {
            if (tradPwdField.type === "text") {
              tradPwdField.type = "password";
              Array.from(document.querySelectorAll(".newReg-password")).forEach(el => el.classList.add("password-visible"));
              event.preventDefault();
            } else {
              tradPwdField.type = "text";
              Array.from(document.querySelectorAll(".newReg-password")).forEach(el => el.classList.remove("password-visible"));
              event.preventDefault();
            }
          })
        );

        confirmBtn.forEach(button =>
          button.addEventListener("click", () => {
            if (tradConfirmPwdField.type === "text") {
              tradConfirmPwdField.type = "password";
              Array.from(document.querySelectorAll(".eyeBtnNewConfirm")).forEach(el => el.classList.add("password-visible"));
              event.preventDefault();
            } else {
              tradConfirmPwdField.type = "text";
              Array.from(document.querySelectorAll(".eyeBtnNewConfirm")).forEach(el => el.classList.remove("password-visible"));
              event.preventDefault();
            }
          })
        );
      }

      if (
        result.screen === "changePassword" ||
        result.screen === "resetPassword" ||
        ((result.screen === "signIn" || result.screen === "signInFull") && result.renderingBuiltInScreen === false)
      ) {
        const newBtnReset = Array.from(document.querySelectorAll(".eyeBtnNewReset"));
        const confirmBtnReset = Array.from(document.querySelectorAll(".eyeBtnConfirmReset"));
        const currentPwdBtn = Array.from(document.querySelectorAll(".eyeBtnCurrentPwd"));
        const changePwdField = document.querySelector<HTMLInputElement>("#capture_changePassword_newPassword");
        const currentPwdField = document.querySelector<HTMLInputElement>(`#capture_${result.screen}_currentPassword`);
        const changeConfirmPwdField = document.querySelector<HTMLInputElement>("#capture_changePassword_newPasswordConfirm");
        const resetPwdField = document.querySelector<HTMLInputElement>("#capture_resetPassword_newPassword");
        const resetConfirmPwdField = document.querySelector<HTMLInputElement>("#capture_resetPassword_newPasswordConfirm");

        // Unmasking in Edit Profile
        newBtnReset.forEach(button =>
          button.addEventListener("click", () => {
            if (changePwdField.type === "text") {
              changePwdField.type = "password";
              Array.from(document.querySelectorAll(".change-password")).forEach(el => el.classList.add("password-visible"));
              event.preventDefault();
            } else {
              changePwdField.type = "text";
              Array.from(document.querySelectorAll(".change-password")).forEach(el => el.classList.remove("password-visible"));
              event.preventDefault();
            }
          })
        );
        currentPwdBtn.forEach(button =>
          button.addEventListener("click", () => {
            if (currentPwdField.type === "text") {
              currentPwdField.type = "password";
              Array.from(document.querySelectorAll(`.${result.screen}-login-password`)).forEach(el => el.classList.add("password-visible"));
              event.preventDefault();
            } else {
              currentPwdField.type = "text";
              Array.from(document.querySelectorAll(`.${result.screen}-login-password`)).forEach(el => el.classList.remove("password-visible"));
              event.preventDefault();
            }
          })
        );

        confirmBtnReset.forEach(button =>
          button.addEventListener("click", () => {
            if (changeConfirmPwdField.type === "text") {
              changeConfirmPwdField.type = "password";
              Array.from(document.querySelectorAll(".change-password-confirm")).forEach(el => el.classList.add("password-visible"));
              event.preventDefault();
            } else {
              changeConfirmPwdField.type = "text";
              Array.from(document.querySelectorAll(".change-password-confirm")).forEach(el => el.classList.remove("password-visible"));
              event.preventDefault();
            }
          })
        );
        newBtnReset.forEach(button =>
          button.addEventListener("click", () => {
            if (resetPwdField.type === "text") {
              resetPwdField.type = "password";
              Array.from(document.querySelectorAll(".reset-password")).forEach(el => el.classList.add("password-visible"));
              event.preventDefault();
            } else {
              resetPwdField.type = "text";
              Array.from(document.querySelectorAll(".reset-password")).forEach(el => el.classList.remove("password-visible"));
              event.preventDefault();
            }
          })
        );
        confirmBtnReset.forEach(button =>
          button.addEventListener("click", () => {
            if (resetConfirmPwdField.type === "text") {
              resetConfirmPwdField.type = "password";
              Array.from(document.querySelectorAll(".reset-password-confirm")).forEach(el => el.classList.add("password-visible"));
              event.preventDefault();
            } else {
              resetConfirmPwdField.type = "text";
              Array.from(document.querySelectorAll(".reset-password-confirm")).forEach(el => el.classList.remove("password-visible"));
              event.preventDefault();
            }
          })
        );
      }
    });
    //#endregion Unmasking Password

    // #Region Google Maps Autocomplete
    /* Autofill address from Google */
    // Region for validating cards before user can navigate to next step in registration. Disable Next Button
    janrain.events.onCaptureValidationSuccess.addHandler(result => {
      if (result.field.id === "capture_traditionalRegistration_newPassword") {
        document.getElementById("capture_traditionalRegistration_form_item_newPasswordConfirm").style.display = "block";
      }
      if (result.field.id === "capture_traditionalRegistration_newPasswordConfirm") {
        document.getElementById("progress-step-3").removeAttribute("disabled");
      }
      if (result.field.id === "capture_traditionalRegistration_mainSpecialty") {
        document.getElementById("progress-step-4").removeAttribute("disabled");
      }
    });

    janrain.events.onCaptureValidationFailed.addHandler(result => {
      // for email field set disabled button after a success attempt
      if (result.field.id === "capture_traditionalRegistration_email") {
        document.getElementById("traditional progress-step-2").setAttribute("disabled", "");
      } else if (result.field.id === "capture_traditionalRegistration_newPasswordConfirm" && result.message === "Passwords do not match.") {
        document.getElementById("progress-step-3").setAttribute("disabled", "");
      } else if (result.field.id === "capture_traditionalRegistration_newPasswordConfirm" && result.message === "Confirm Password is required.") {
        document.getElementById("progress-step-3").setAttribute("disabled", "");
      } else if (result.field.id === "capture_traditionalRegistration_mainSpecialty" && result.message === "Specialty is required.") {
        document.getElementById("progress-step-4").setAttribute("disabled", "");
      }
    });

    janrain.events.onCaptureValidationComplete.addHandler(function(result) {
      console.log("onCaptureValidationComplete");
      console.log(result);
    });

    //#region Dynamic Log-in Screen
    const LoginScreenFactory = {
      action: null,
      errorMessageElement: null,
      transactionId: null,
      statusMessage: null,
      fieldValues: {
        preregEmailAddress: null
      }
    };

    const Login = Object.create(LoginScreenFactory);

    janrain.events.onCaptureRenderComplete.addHandler(result => {
      if (result.screen === "signIn" || result.screen === "signInFull") {
        const storedName = localStorage.getItem("uname");
        const preregEmailAddressFormWrapper = document.getElementById(`${result.screen}_preregEmailAddressFormWrapper`);
        const signInEmailAddress = window.DigitalIdentityHub.utilities.getCaptureFormItem(result.screen, "signInEmailAddress");
        const signInEmailAddressInput = document.getElementById(`capture_${result.screen}_signInEmailAddress`) as HTMLInputElement;
        const unameField = document.getElementById(`${result.screen}_rememberUname`) as HTMLInputElement;

        // Check for errors
        if (!Login.statusMessage) {
          // If no errors, evaluate 'storedName'. If 'storedName' != null then execute rememberMe flow, else, proceed with standard signIn flow.
          if (storedName != null) {
            preregEmailAddressFormWrapper.style.display = "none";
            signInEmailAddress.style.display = "block";
            signInEmailAddressInput.value = storedName;
            document.querySelector<HTMLElement>(`.sso-password.password-visible.${result.screen}-login-password`).style.display = "block";
            document.getElementById(`${result.screen}_submit`).style.display = "block";
            document.getElementById(`${result.screen}_rememberMeBox`).style.display = "block";
            document.querySelector<HTMLAnchorElement>(".sso-forgot-password").style.display = "block";
            unameField.setAttribute("checked", "");
          } else {
            signInEmailAddress.style.display = "none";
            preregEmailAddressFormWrapper.style.display = "block";
          }
        } else {
          // Error: Show the password field
          document.querySelector<HTMLElement>(`.sso-password.password-visible.${result.screen}-login-password`).style.display = "block";
          document.getElementById(`${result.screen}_step_1_button`).style.display = "none";
          document.getElementById(`${result.screen}_submit`).style.display = "block";
          document.getElementById(`${result.screen}_rememberMeBox`).style.display = "block";
          document.querySelector<HTMLAnchorElement>(".sso-forgot-password").style.display = "block";
        }

        // Assign event listener
        document.getElementById(`${result.screen}_step_1_button`).addEventListener("click", validatePreregInput);

        document.getElementById(`capture_${result.screen}_signInEmailAddress`).addEventListener("change", event => {
          const preregFormFieldInput = document.getElementById(`capture_${result.screen}_preregEmailAddress`) as HTMLInputElement;

          if (Login.statusMessage) {
            const signInFormErrorElement = document.getElementById(`capture_${result.screen}_signInForm_errorMessages`).childNodes[0].cloneNode(true);
            const preregFormErrorMsg = document.getElementById(`capture_${result.screen}_preregForm_errorMessages`);
            Login.errorMessageElement = signInFormErrorElement;

            if (preregFormErrorMsg.childNodes.length === 0) {
              preregFormErrorMsg.appendChild(Login.errorMessageElement);
            }

            document.querySelector<HTMLElement>(`form#capture_${result.screen}_signInForm div#capture_${result.screen}_signInForm_errorMessages`)
              .style.display = "none";
          }

          signInEmailAddress.style.display = "none";
          preregFormFieldInput.value = (event.target as HTMLTextAreaElement).value;
          preregEmailAddressFormWrapper.style.display = "block";
          preregFormFieldInput.focus();
          preregFormFieldInput.blur();
        });
      }
    });

    // If the validation message is pre-registered submit reset password flow
    janrain.events.onCaptureValidationFailed.addHandler(function(result) {
      if ((result.field.id === "capture_signIn_preregEmailAddress" || result.field.id === "capture_signInFull_preregEmailAddress" || result.field.id === "capture_traditionalRegistration_preregEmailAddress") && result.message === "pre-registered") {
        const { currentScreenName } = janrain.settings.capture;
        document.querySelector(`div#capture_${currentScreenName}_form_item_preregEmailAddress div.capture_tip_error` )!.remove();

        Login.fieldValues.preregEmailAddress = `${result.field.value}`;
        janrain.capture.ui.postCaptureForm("createPasswordForm", Login.fieldValues);
      }
    });

    janrain.events.onCaptureValidationSuccess.addHandler(result => {
      if (result.field.id === "capture_signIn_preregEmailAddress" || result.field.id === "capture_signInFull_preregEmailAddress") {
        // Check if preregEmailAddress is still visible.
        const { currentScreenName } = janrain.settings.capture;
        const isPreregVisible = document.getElementById(`${currentScreenName}_preregEmailAddressFormWrapper`).style.display === "block";

        if (isPreregVisible) {
          const preRegEmailAddressText = window.DigitalIdentityHub.utilities.getCaptureField(currentScreenName, "preregEmailAddress")!.value;
          const signInEmailAddressText = window.DigitalIdentityHub.utilities.getCaptureField(currentScreenName, "signInEmailAddress");
          signInEmailAddressText.value = preRegEmailAddressText;

          // Hide pre-reg email form and button
          document.getElementById(`${currentScreenName}_preregEmailAddressFormWrapper`).style.display = "none";
          document.getElementById(`${currentScreenName}_step_1_button`).style.display = "none";

          // Display signIn form level error message
          document.getElementById(`capture_${currentScreenName}_signInForm_errorMessages`).style.display = "block";

          // Display signInForm and button
          document.getElementById(`capture_${currentScreenName}_form_item_signInEmailAddress`).style.display = "block";
          document.querySelector<HTMLElement>(`.${currentScreenName}-login-password`).style.display = "block";
          document.getElementById(`${currentScreenName}_rememberMeBox`).style.display = "block";
          document.getElementById(`${currentScreenName}_submit`).style.display = "block";
          document.querySelector<HTMLInputElement>(".sso-forgot-password").style.display = "inline-block";
        }
      }
    });

    janrain.events.onCaptureSaveFailed.addHandler(result => {
      const currentScreenName = janrain.settings.capture.currentScreenName;
      const action = result.action;
      const statusMessage = result.statusMessage;
      const transactionId = result.transactionId;

      if (currentScreenName === "signIn" || currentScreenName === "signInFull" || currentScreenName === "traditionalRegistration") {
        Login.action = action;
        Login.statusMessage = statusMessage;
        Login.transactionId = transactionId;
      }
    });
    //#endregion Dynamic Log-in Screen

    //#region for Remember Me Button
    janrain.events.onCaptureValidationComplete.addHandler(function() {
      const { currentScreenName } = janrain.settings.capture;
      const unameField = document.getElementById(`${currentScreenName}_rememberUname`) as HTMLInputElement;
      const signInField = document.getElementById(`capture_${currentScreenName}_signInEmailAddress`) as HTMLInputElement;

      if (unameField.checked === true) {
        localStorage.setItem("uname", signInField.value);
      } else {
        localStorage.removeItem("uname");
      }
    });
    //#endregion for Remember Me

    janrain.events.onCaptureRenderComplete.addHandler(result => {
      if (result.screen === "traditionalRegistration" && result.renderingBuiltInScreen === false) {
        // Screen
        const currentScreen = result.screen;

        // Breadcrumbs
        const emailBreadcrumb = document.getElementById("breadcrumb-step-1");
        const passwordBreadcrumb = document.getElementById("breadcrumb-step-2");
        const professionalBreadcrumb = document.getElementById("breadcrumb-step-3");
        const practiceBreadcrumb = document.getElementById("breadcrumb-step-4");

        // Cards
        const preregEmailCard = document.getElementById("prereg registration-step-1");
        const emailCard = document.getElementById("traditional registration-step-1");
        const passwordCard = document.getElementById("traditional registration-step-2");
        const professionalInfoCard = document.getElementById("registration-step-3");
        const practiceInfoCard = document.getElementById("registration-step-4");

        // Buttons
        const preregSubmit = document.getElementById("preregSubmit") as HTMLButtonElement;
        const passwordBack = document.getElementById("regress-step-1") as HTMLButtonElement;
        const passwordNext = document.getElementById("progress-step-3") as HTMLButtonElement;
        const professionalBack = document.getElementById("regress-step-2") as HTMLButtonElement;
        const professionalNext = document.getElementById("progress-step-4") as HTMLButtonElement;
        const practiceBack = document.getElementById("regress-step-3") as HTMLButtonElement;
        const registrationSubmit = document.getElementById("progress-step-5") as HTMLButtonElement;

        // Fields
        const preregEmailAddress = document.getElementById(`capture_${currentScreen}_preregEmailAddress`) as HTMLInputElement;
        const emailAddress = document.getElementById(`capture_${currentScreen}_email`) as HTMLInputElement;
        const customerType = document.getElementById(`capture_${currentScreen}_customerType`) as HTMLSelectElement;
        const mainSpecialtyFormItem = document.getElementById(`capture_${currentScreen}_form_item_mainSpecialty`);
        const licenseTypeFormItem = document.getElementById(`capture_${currentScreen}_form_item_licenseType`);
        const licenseNumberFormItem = document.getElementById(`capture_${currentScreen}_form_item_licenseNumber`);

        // Office Manager
        const officeManager = "09-OT-OT-OFM";

        let formSubmitted = false;

        // Functions
        const validationCompletion = fieldsBeingValidated => {
          return new Promise(resolve => {
            const observer = new MutationObserver(mCallback);
            const options = {
              attributes: true
            };

            for (const element of fieldsBeingValidated) {
              console.log(element);
              console.log(element.parent);
              observer.observe(element.parent, options);
              element.field.focus();
              element.field.blur();
            }

            function mCallback(mutations) {
              for (const mutation of mutations) {
                console.log(`A mutation occurred to attribute name: ${mutation.attributeName}`);
                console.log(`Class List: ${mutation.target.classList}`);
              }
              observer.disconnect();
              resolve("Finish");
            }
          });
        };

        const validationHandler = async(fieldsFromCard: NodeList) => {
          // Determine if the field needs to be validated
          const fieldsToValidate = [];

          const a = Array(fieldsFromCard.length);
          const c = a.length;

          for (let b = 0; b < c; b++) {
            a[b] = fieldsFromCard[b];
          }

          a.forEach(field => {
            const fieldType = field.tagName;
            const parentElem = fieldType === "INPUT" ? field.parentElement : field.parentElement.parentElement;
            console.log(`Parent Elem: ${parentElem.id}`);
            console.log(`Parent - Class: ${parentElem.classList} | Display: ${parentElem.style.display}`);
            console.log(`Field - Disabled: ${field.disabled} | Display: ${field.style.display}`);

            if (!(parentElem.classList.contains("disabled") || parentElem.style.display === "none")) {
              if (!(field.disabled === true || field.style.display === "none")) {
                const fieldObj = {
                  field,
                  parent: parentElem
                };

                fieldsToValidate.push(fieldObj);
              }
            }
          });

          return validationCompletion(fieldsToValidate);
        };

        const validatePreregForm = event => {
          event.preventDefault();

          // Checking focusing and blurring every single field to check for any errors
          preregEmailAddress.focus();
          preregEmailAddress.blur();
        };

        const validateEmailInput = (email: string) => {
          // Change registration card visibility
          preregEmailCard.style.display = "none";
          emailCard.style.display = "block";

          // Add prereg email value to traditional email and check the field for any errors
          emailAddress.value = email;
          emailAddress.focus();
          emailAddress.blur();
        };

        const goToPasswordCard = () => {
          // Breadcrumb
          emailBreadcrumb.classList.add("complete");
          passwordBreadcrumb.classList.add("active");

          // Hide Email Step 1b fields
          emailCard.style.display = "none";

          // Show Password Card and Buttons
          passwordCard.style.display = "block";
          passwordBack.style.display = "block";
          passwordNext.style.display = "block";
        };

        const backToEmailCard = () => {
          // Breadcrumb
          emailBreadcrumb.classList.remove("complete");
          passwordBreadcrumb.classList.remove("active");

          // Hide Password Card
          passwordCard.style.display = "none";

          // Show Email Card
          preregEmailCard.style.display = "block";

          // Clear errorObj of any errors incurred on the current screen.
          if (Object.keys(errorObj).length > 0) {
            Object.keys(errorObj).forEach(key => delete errorObj[key]);
          }
        };

        const goToProfessionalInfoCard = async() => {
          const fields = passwordCard.querySelectorAll("input, select");

          await validationHandler(fields);
          console.log("Validation Complete");
          console.log(Object.keys(errorObj));

          if (Object.keys(errorObj).length < 1) {
            // Breadcrumb
            passwordBreadcrumb.classList.add("complete");
            professionalBreadcrumb.classList.add("active");

            // Hide Password Card
            passwordCard.style.display = "none";

            // Show Professional Info Card
            professionalInfoCard.style.display = "block";

            if (customerType.value === "" || customerType.value === officeManager) {
              mainSpecialtyFormItem.style.display = "none";
              licenseTypeFormItem.style.display = "none";
              licenseNumberFormItem.style.display = "none";
            }

            // Show Buttons
            professionalBack.style.display = "block";
            professionalNext.style.display = "block";
          }
        };

        const backToPasswordCard = () => {
          // Breadcrumb
          passwordBreadcrumb.classList.remove("complete");
          professionalBreadcrumb.classList.remove("active");

          // Hide Professional Card
          professionalInfoCard.style.display = "none";

          // Show Password Card
          passwordCard.style.display = "block";

          // Clear errorObj of any errors incurred on the current screen.
          if (Object.keys(errorObj).length > 0) {
            Object.keys(errorObj).forEach(key => delete errorObj[key]);
          }
        };

        const goToPracticeCard = async() => {
          const fields = professionalInfoCard.querySelectorAll("input, select");

          await validationHandler(fields);
          console.log("Validation Complete");
          console.log(Object.keys(errorObj));

          if (Object.keys(errorObj).length < 1) {
            // Breadcrumb
            professionalBreadcrumb.classList.add("complete");
            practiceBreadcrumb.classList.add("active");

            // Hide Professional Card
            professionalInfoCard.style.display = "none";

            // Show Practice Card
            practiceInfoCard.style.display = "block";

            // Show Buttons
            practiceBack.style.display = "block";
            registrationSubmit.style.display = "block";
          }
        };

        const backToProfessionalCard = () => {
          // Breadcrumb
          professionalBreadcrumb.classList.remove("complete");
          practiceBreadcrumb.classList.remove("active");

          // Hide Professional Card
          practiceInfoCard.style.display = "none";

          // Show Password Card
          professionalInfoCard.style.display = "block";

          if (customerType.value === officeManager) {
            mainSpecialtyFormItem.style.display = "none";
            licenseTypeFormItem.style.display = "none";
            licenseNumberFormItem.style.display = "none";
          }

          // Reset formSubmitted if true
          if (formSubmitted) {
            formSubmitted = false;
          }

          // Clear errorObj of any errors incurred on the current screen.
          if (Object.keys(errorObj).length > 0) {
            Object.keys(errorObj).forEach(key => delete errorObj[key]);
          }
        };

        // Janrain Events
        janrain.events.onCaptureValidationSuccess.addHandler(res => {
          const fieldId = res.field.id;
          const screen = (() => {
            return fieldId.split("_")[1];
          })();

          if (screen === "traditionalRegistration") {
            if (Object.keys(errorObj).length > 0) {
              // Remove 'fieldId' from errorObj.
              delete errorObj[`${fieldId}`];
            }

            if (!formSubmitted) {
              if (res.field.id === "capture_traditionalRegistration_preregEmailAddress") {
                const userEmail = res.field.value;
                validateEmailInput(userEmail);
              }

              if (res.field.id === "capture_traditionalRegistration_email") {
                goToPasswordCard();
              }
            }
          }
        });
        // REGION Handler for adding error fiels on top of Registration Page on last card
        janrain.events.onCaptureValidationFailed.addHandler(res => {
          const fieldId = res.field.id;

          const screen = (() => {
            return fieldId.split("_")[1];
          })();

          if (screen === "traditionalRegistration") {
            errorObj[`${fieldId}`] = {
              fieldId: `${fieldId}`,
              fieldName: `${res.field.placeholder}`,
              message: `${res.message}`,
              fieldLabel: `${res.field.labels[0].firstChild.data}`
            };
            console.log(`My Errors: ${JSON.stringify(errorObj)}`);
          }
        });

        janrain.events.onCaptureValidationComplete.addHandler(() => {
          if (janrain.settings.capture.currentScreenName === "traditionalRegistration") {
            if (Object.keys(errorObj).length > 0) {
              // if errorObj{} is not empty lets show the user the errors.
              const errorDiv = document.getElementById("errorContainer");
              // styling the new contents
              errorDiv.style.color = "#db281a";
              errorDiv.style.fontSize = "10px";
              // deletes the container holding the errors if user clicks submit
              while (errorDiv.firstChild) {
                errorDiv.removeChild(errorDiv.firstChild);
              }

              errorDiv.innerHTML += "Please fix the errors in the following fields: ";
              for (const [, value] of Object.entries(errorObj)) {
                const ul = document.createElement("ul");
                const li = document.createElement("li");
                li.textContent = `${value.fieldLabel}: ${value.message}`;
                errorDiv.appendChild(ul);
                ul.appendChild(li);
                li.style.color = "#db281a";
                li.style.fontSize = "10px";
              }

              window.scrollTo(0, 0);
            }
          }
        });
        // END REGION

        // Event listeners
        preregSubmit.addEventListener("click", validatePreregForm);
        passwordBack.addEventListener("click", backToEmailCard);
        passwordNext.addEventListener("click", goToProfessionalInfoCard);
        professionalBack.addEventListener("click", backToPasswordCard);
        professionalNext.addEventListener("click", goToPracticeCard);
        practiceBack.addEventListener("click", backToProfessionalCard);
        registrationSubmit.addEventListener("click", () => (formSubmitted = true));
      }
    });

    /**
     * ===================================
     * Consent Widget Functionality
     * ===================================
     *
     * -----------------------------------
     * Unsubscribe Widget
     *
     * @pathname must include /unsubscribe
     * @param must include a valid token as query parameter
     * -----------------------------------
     */

    function waitForCOHWidgetToLoad(id) {
      return new Promise(resolve => {
        const interval = setInterval(() => {
          const elementClass = document.querySelector(`${id}`);
          if (elementClass) {
            clearInterval(interval);
            resolve(true);
          }
        }, 100);
      });
    }

    const addUnsubscribeToConsentHubHost = () => {
      const consentHubHost = document.querySelector("#ConsentHubHost");
      consentHubHost.classList.add("unsubscribe", "no-padding");
      const noPadding = document.querySelector<HTMLElement>(".no-padding");
      noPadding.style.padding = "0px";
    };

    const changeConsentHeaderText = (text: string) => {
      const header = document.querySelector(".widget-consent-header");
      header.textContent = text;
    };

    const changeChannelHeaderText = () => {
      const header = document.querySelector(".widget-channel-header");
      header.textContent = "You previously requested information from Merck on each of the topics checked below. If you no longer want to receive emails on one or more of these topics, please unselect the topic(s) you wish to unsubscribe from. You can also \"unsubscribe all\" to be removed from all topic emails.";
    };

    const modifyChannelFormTextStyles = () => {
      const channelFormText = [...Array.from(document.querySelectorAll(".widget-channel-form-text"))];
      channelFormText.forEach(i => i.classList.add("unsubscribe"));
    };

    const showUnsubscribeCheckbox = () => {
      const unsubscribeElement = document.querySelector(".widget-channel-form-unsubscribe");
      unsubscribeElement.classList.add("unsubscribe");
    };

    const showUnsubscribeAllSuccessMessage = () => {
      const formStatusMessage = document.querySelector<HTMLElement>(".widget-channel-form-status");
      formStatusMessage.style.display = "block";
    };

    const removeChangesSavedOnInputChange = () => {
      const unsubscribeInputs = [...Array.from(document.querySelectorAll('.widget-channel-form-preference input[type="checkbox"]'))];

      unsubscribeInputs.forEach(input => {
        input.addEventListener("change", updateSubmitBtn);
      });
    };

    const wasUnsubscribeChecked = () => {
      const wasChecked = (value: string) => {
        if (value === "true") {
          return true;
        } else if (value === "false") {
          return false;
        }
      };

      return wasChecked((document.querySelector<HTMLInputElement>('input[name="unsubscribe"]')).value);
    };

    const taskRunner = async() => {
      const isChecked = wasUnsubscribeChecked();
      const loaded = waitForCOHWidgetToLoad(".widget-channel-form-status");

      return {
        isChecked: isChecked,
        loaded: await loaded
      };
    };

    const updateHandler = async e => {
      const submitBtn = e.target;
      const saving = "Saving...";
      const saved = "Changes saved";
      submitBtn.textContent = saving;

      const result = await taskRunner();

      if (result.loaded) {
        submitBtn.textContent = saved;
        submitBtn.classList.add("changes-saved");
        submitBtn.classList.add("sso-btn-save");

        if (result.isChecked) {
          showUnsubscribeAllSuccessMessage();
        }
      }

      removeChangesSavedOnInputChange();
    };

    const updateSubmitBtn = (e?: Event) => {
      const updateBtn = document.querySelector('.widget-channel-form-button[type="submit"]');
      updateBtn.textContent = "Save changes";

      // Add event listener
      updateBtn.addEventListener("click", updateHandler);

      if (e) {
        e.target.removeEventListener("change", updateSubmitBtn);
        updateBtn.classList.remove("sso-btn-save");
      } else {
        const formControlsElement = document.querySelector(".widget-channel-form-controls");
        formControlsElement.classList.add("unsubscribe");
      }
    };

    const updateUnsubscribeText = () => {
      if (!document.querySelector(".widget-channel-form-unsubscribe-notification")) {
        const unsubscribe = document.querySelector(".widget-channel-form-unsubscribe");
        const unsubscribeTextSpan = document.createElement("span");

        unsubscribeTextSpan.className = "widget-channel-form-unsubscribe-notification";
        unsubscribeTextSpan.textContent = "Please note that even if you unsubscribe, you will continue to receive email communication about any orders you place.";

        unsubscribe.parentNode.insertBefore(unsubscribeTextSpan, unsubscribe.nextSibling);
      }
    };

    const modifyConsentWidget = async() => {
      const imtoken = window.DigitalIdentityHub.utilities.getParameterByName("imtoken");

      addUnsubscribeToConsentHubHost();

      const widgetLoaded = await waitForCOHWidgetToLoad(".widget-consent");

      if (widgetLoaded) {
        const headerText = imtoken ? "Update Email Preferences" : "Email Preferences";

        changeConsentHeaderText(headerText);
        modifyChannelFormTextStyles();
        updateSubmitBtn();

        if (imtoken) {
          showUnsubscribeCheckbox();
          changeChannelHeaderText();
        } else {
          updateUnsubscribeText();
        }
      }
    };

    janrain.events.onCaptureRenderComplete.addHandler(result => {
      const currPathname = window.location.pathname.toLowerCase();
      const imtoken = window.DigitalIdentityHub.utilities.getParameterByName("imtoken");

      // Display's COH widget when user has authenticated and is on editProfile page. Otherwise, the ConsentHub widget is set to display:none;
      const consentHubHost = document.getElementById("ConsentHubHost");
      const digitalIdentityHubHost = document.getElementById("DigitalIdentityHubHost");

      if (result.screen === "editProfile" && result.renderingBuiltInScreen === false && janrain.capture.ui.hasActiveSession) {
        // Edit Profile: The COH widget will be displayed.
        void modifyConsentWidget();
        consentHubHost.style.display = "block";
      } else if (currPathname.includes("/unsubscribe")) {
        // Unsubscribe Page: The DIH widget will NOT be displayed.
        digitalIdentityHubHost.style.display = "none";

        // If the URL contains an `imtoken`, show the COH widget, but if the URL doesn't contain an `imtoken`, don't show the COH widget.
        if (imtoken) {
          void modifyConsentWidget();
          consentHubHost.style.display = "block";
        } else {
          consentHubHost.style.display = "none";
        }
      } else {
        // All other pages: The COH widget will NOT be displayed.
        consentHubHost.style.display = "none";
      }
    });

    // Janrain Flow Version
    janrain.events.onCaptureRenderStart.addHandler(function(result) {
      janrain.settings.capture.flowVersionNumber = result.version;
      console.log("Flow Version:", result.version);
    });
  },

  init() {
    janrain.settings.capture.federateSegment = "US";
    janrain.settings.capture.flowName = "us_consent";
    janrain.settings.capture.flowVersion = "HEAD";
    janrain.settings.capture.registerFlow = "traditionalRegistration";
    janrain.settings.capture.ignoreEmailVerificationRequiredScreen = "true";
    janrain.settings.language = "en-US";
    // Social login is not applicable for US market
    janrain.settings.providers = [];
    janrain.settings.custom = true;

    // Consent Hub Channels
    window.DigitalIdentityHub.modules.ConsentWidget.consentChannels = profileData => ({
      ME: profileData.email ? profileData.email : null
    });

    // Janrain Translations
    window.DigitalIdentityHub.translations["en-US"] = {
      "Triggering email change process": "Processing your request, please wait",
      "Error triggering email change process":
        "Sorry, the system was not able to update your email address. Please return to your profile settings or try again. For immediate assistance, please call our technical support service at: 1-800-489-5119 (Monday-Friday 8AM-7PM ET)",
      "Confirmation email sent, check your inbox for further instructions": "Email sent. Verify your new email address by following the instructions in your email",
      "Sign In": "Continue",
      "Create Account": "Register",
      Send: "Reset password",
      Processing: "Saving..."
    };
  }
};

function validatePreregInput(e) {
  e.preventDefault(); // Prevents preregForm from submitting when users clicks enter after entering their email.
  const { currentScreenName } = janrain.settings.capture;
  // Validate pre-reg email address if user clicks the "Continue" button.
  window.DigitalIdentityHub.utilities.getCaptureField(currentScreenName, "preregEmailAddress")!.focus();
  window.DigitalIdentityHub.utilities.getCaptureField(currentScreenName, "preregEmailAddress")!.blur();
}
